import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import TElogo from "../../../assets/images/logopng13.png";
import TElogo from "../../../../assets/images/dod_logo.png";
import { FaArrowLeft } from "react-icons/fa6";
import BtnLoader from "../../../components/Loader/btnLoader";
import { Toaster } from "../../../components/Toaster/Toster";
import { adminForgotPasswordApi } from "../../../../services/apis/AuthService";

function AdminForgotPasswordTE() {
  const [email, setEmail] = useState();
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [submitted, setSubmitted] = useState(false);
  const [btnLoading,setBtnLoading]=useState(false);
  const navigate = useNavigate();

  // Validation logic
  const validateFields = () => {
    const errorObj = { email: "", password: "" };
    let isError = false;
    if (!email) {
      errorObj.email = "Email is required";
      isError = true;
    }
    
    setErrors(errorObj);
    return isError;
  };

  // Reset the specific error when the user starts typing
  const handleInputChange = (e, field) => {
    if (field === "email") {
      setEmail(e.target.value);
      if (submitted && errors.email) {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      }
    }
  };

  const handleUserForgotPassword = async (e) => {
    e.preventDefault();
    const isFormValid = validateFields();
    if (isFormValid) {
      return; 
    }
    const formData = {
      email: email,
    };      
    setBtnLoading(true);
    try {
      // const res = await userForgotPasswordApi(formData);
      const res =await adminForgotPasswordApi(formData);
       //console.log(res)
       const resData= res?.data;
       const stateData={
        email:email,
        // otp:resData?.otp
      }
      if (resData.success) {
        navigate("/otp-varification", {state:stateData});
        Toaster.success(res?.data?.message);
      } else {
        console.log("Login not successfully done");
      }

      console.log("resss",res)
    } catch (err) {
      console.log(err);
      Toaster.error(err.response?.data?.message);
    }finally{
      setBtnLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="w-100">
          <div className="row login-mainsection-background">
            <div className="col-12 col-lg-12 login-right-section d-flex flex-column justify-content-center">
              <div className=" login-right-content-section">
                <div className="card login-card mb-0 h-auto">
                  <div className="card-body">
                    {/* logo */}
                    <div className="d-flex justify-content-center mb-2">
                      <Link to={"/user/login"}>
                        <img
                          src={TElogo}
                          alt="logo"
                          style={{ height: "80px", width: "auto" }}
                        />
                      </Link>
                    </div>
                    {/* Tag or intro Line */}
                    <h4 className="login-welcome-text">Forgot password</h4>
                    <p className="mb-3 text-black">Enter your email address and your password will be reset and emailed to you.</p>

                    {/* Form */}
                    <form onSubmit={handleUserForgotPassword}>
                      <div className="mb-3">
                        <label className="mb-1 text-dark">
                          <strong>Email</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          // onChange={(e) => setEmail(e.target.value)}
                          onChange={(e) => handleInputChange(e, "email")}
                          placeholder="Type Your Email Address"
                        />
                        {errors.email && (
                          <div className="text-danger fs-12">
                            {errors.email}
                          </div>
                        )}
                      </div>
                      
                      <div className="">
                        <button
                          type="submit"
                          className="btn text-white btn-block handle-login-btn">
                          { btnLoading && <BtnLoader/> } Submit
                        </button>

                        <button
                          type="submit"
                          className="btn text-black mt-3 px-0"
                          onClick={()=>navigate(-1)}>
                           <FaArrowLeft/> Go back
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminForgotPasswordTE;
